import { axiosInstance } from '~/services';

import type { TypeGetOwnerSupplierParams, TypeGetOwnerSupplierResponse } from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 목록 조회
 */
const useGetOwnerSupplier = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplier = async (params: TypeGetOwnerSupplierParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierResponse>(endPoint, { params })
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplier };
};

export default useGetOwnerSupplier;
